(() => {
  function init() {
    const root = document.querySelector('[data-eb-faith-page]');
    if (!root || root.dataset.ebFaithReady === 'true') return;
    const more = root.querySelector('[data-eb-faith-toggle]');
    const extras = [...root.querySelectorAll('[data-eb-faith-extra]')];
    if (more && extras.length) {
      extras.forEach(item => { item.hidden = true; });
      more.hidden = false;
      more.addEventListener('click', () => {
        const expanded = more.getAttribute('aria-expanded') === 'true';
        extras.forEach(item => { item.hidden = expanded; });
        more.setAttribute('aria-expanded', String(!expanded));
        more.textContent = expanded ? `View all ${root.querySelectorAll('[data-eb-faith-group="faith-worth-belonging"] .eb-merch-faith__item').length} designs` : 'Show fewer designs';
      });
    }
    function legacyGiftRedirect() {
      let hash;
      try { hash = decodeURIComponent(location.hash.slice(1)); } catch { return; }
      if (hash === 'gift-affirmation' || hash === 'section-5') location.replace('/pages/meaningful-gifts');
    }
    root.dataset.ebFaithReady = 'true';
    legacyGiftRedirect();
    window.addEventListener('hashchange', legacyGiftRedirect);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();
